import { useEffect, useState } from "react";
import { Youtube, Link2, RefreshCw } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export const YoutubeConnectCard = ({ slot, label, onStatusChange }) => {
  const [status, setStatus] = useState({ connected: false });
  const [loading, setLoading] = useState(false);

  const loadStatus = async () => {
    try {
      const res = await api.get(`/youtube/auth/status?slot=${slot}`);
      setStatus(res.data);
      onStatusChange?.(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    loadStatus();
    const params = new URLSearchParams(window.location.search);
    if (params.has("youtube_connected") && params.get("slot") === slot) {
      if (params.get("youtube_connected") === "true") {
        toast.success(`${label} YouTube account connected!`);
      } else {
        toast.error(`Could not connect the ${label} YouTube account.`);
      }
      window.history.replaceState({}, "", window.location.pathname);
      loadStatus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const connect = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/youtube/auth/login?slot=${slot}`);
      window.location.href = res.data.auth_url;
    } catch (e) {
      toast.error("Failed to start YouTube connection");
      setLoading(false);
    }
  };

  return (
    <div
      data-testid={`youtube-connect-card-${slot}`}
      className="flex items-center justify-between gap-3 bg-slate-900/60 border border-slate-800/80 rounded-xl px-4 py-3"
    >
      <span className="text-sm text-slate-300 flex items-center gap-2">
        <Youtube className="w-4 h-4 text-red-500" /> {label} <span className="text-slate-500">YouTube channel</span>
      </span>
      {status.connected ? (
        <div className="flex items-center gap-2">
          <span
            data-testid={`youtube-connected-badge-${slot}`}
            className="bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 px-3 py-1 rounded-full text-xs font-mono font-medium flex items-center gap-1.5"
          >
            <Link2 className="w-3 h-3" /> {status.channel_title || "Connected"}
          </span>
          <button
            data-testid={`youtube-reconnect-button-${slot}`}
            onClick={connect}
            disabled={loading}
            title="Connect a different account just for this tool"
            className="bg-slate-800/80 hover:bg-slate-700 text-slate-300 border border-slate-700/60 p-1.5 rounded-lg transition-all disabled:opacity-60"
          >
            <RefreshCw className={`w-3.5 h-3.5 ${loading ? "animate-spin" : ""}`} />
          </button>
        </div>
      ) : (
        <button
          data-testid={`youtube-connect-button-${slot}`}
          onClick={connect}
          disabled={loading}
          className="bg-red-600 hover:bg-red-500 text-white font-medium px-3 py-1.5 rounded-lg flex items-center gap-1.5 transition-all text-xs disabled:opacity-60"
        >
          <Youtube className="w-3.5 h-3.5" /> {loading ? "Connecting..." : "Connect"}
        </button>
      )}
    </div>
  );
};
